<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
    <g fill="none" fill-rule="evenodd">
      <circle cx="12.5" cy="12.5" r="12.5" />
      <path
        fill="#FFF"
        d="M12.999 11.09l3.68-3.68c1.257-1.258 3.167.667 1.91 1.925l-3.665 3.664 3.664 3.68c1.258 1.258-.651 3.168-1.91 1.91l-3.68-3.664-3.663 3.664c-1.258 1.258-3.183-.652-1.91-1.91L11.089 13l-3.68-3.664c-1.257-1.258.668-3.183 1.926-1.926l3.664 3.68z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RedCross'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

circle {
  fill: $wrong-color;
}
</style>
